import FontFaceObserver from 'fontfaceobserver';
// Initialize languages
import 'locales/i18n';
import React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import ErrorFallBackComponent from 'shared/components/ErrorFallBackComponent/ErrorFallBackComponent';
import { __prod__ } from 'shared/constants/common';
import Sentry, { initSentry } from 'shared/utils/sentry';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Observe loading of Gilroy (to remove 'Gilroy', remove the <link> tag in
// the index.html file and this observer)
const gilroyObserver = new FontFaceObserver('SVN Gilroy', {});

// When Gilroy is loaded, add a font-family using Gilroy to the body
gilroyObserver.load().then(() => {
  document.body.classList.add('font-gilroy');
});

const MOUNT_NODE = document.getElementById('root') as HTMLElement;

if (__prod__) {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

initSentry();

ReactDOM.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallBackComponent />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
  MOUNT_NODE
);

// Hot reloadable translation json files
if (module.hot) {
  module.hot.accept(['./locales/i18n'], () => {
    // No need to render the App again because i18next works with the hooks
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
